histories-tasks-memo-updated
  span.event {this.locale().event}
  span.created
    span.label.label-sm(style="background: {phaseColorCode()}")
      span.day_prefix { this.locale().day_prefix }
      span.day { opts.json.index + 1 }
      span.day_suffix { this.locale().day_suffix }
    histories-updated.num(if="{opts.json.num != undefined}" tag-scope="{this.tagScope}" scope="num" locale="{locale()}" getter="{straight}")
    histories-updated.text(if="{opts.json.text != undefined}" tag-scope="{this.tagScope}" scope="text" locale="{locale()}" getter="{straight}")
  script(type="typescript").
    this.mixin('histories.base');
